<div class="kamona-alert-banner flex flex-1 items-stretch w-full" [ngClass]="{'my-5': verticalMargin}">
	<div class="w-full" [class]="bannerType">
		<ng-container *ngIf="!isMobile">
			<div class="notification-bar-container h-full">
				<div class="flex gap-[24px] w-full items-center h-full" [class]="buttonPositioningClass">
					<div class="flex gap-[24px] justify-start items-center w-full">
						<div>
							<i class="icon web-custom-icon" *ngIf="iconPath" nz-icon [nzType]="iconPath"></i>
							<svg *ngIf="!iconPath" fill="none" height="80" class="icon" viewBox="0 0 80 80" width="80"
								xmlns="http://www.w3.org/2000/svg">
								<rect fill="currentColor" fill-opacity="0.3" height="80" rx="19" width="80" />
								<rect fill="currentColor" height="64" rx="16" width="64" x="8" y="8" />
								<path
									d="M40 61C28.9543 61 20 52.0457 20 41C20 29.9543 28.9543 21 40 21C51.0457 21 60 29.9543 60 41C59.9879 52.0407 51.0407 60.9879 40 61ZM38 47V51H42V47H38ZM38 31V43H42V31H38Z"
									fill="white" />
							</svg>
						</div>
						<div [class]="contentClass" class="h-full">
							<div class="notification-bar-title">
								{{title}}
							</div>
							<ng-container [ngSwitch]="messageType">
								<ng-container *ngSwitchCase="messageTypes.text">
									<div class="notification-bar-msg m-t-4" [innerHTML]="message">
									</div>
								</ng-container>
								<ng-container *ngSwitchCase="messageTypes.template">
									<div class="notification-bar-msg m-t-4">
										<ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
									</div>
								</ng-container>

							</ng-container>
						</div>
					</div>
					<div class="flex justify-end" [ngClass]="{ 'mt-[16px] w-full': actionTemplate && wrapAction }">
						<ng-container *ngIf="!actionTemplate; else actionTemplate">
							<div class="ml-auto button-size-80 banner-button">
								<app-custom-submit-button [prefixIcon]="buttonPrefixIcon"
									[suffixIcon]="buttonSuffixIcon" [ngClass]="{'hidden': !buttonText}"
									(submitForm)="submit()" [name]="buttonText" [submitting]="buttonLoading">
								</app-custom-submit-button>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="isMobile">
			<div class="notification-bar-container-sm h-full">
				<div class="flex gap-[12px] h-full py-[12px]">
					<div [class]="useSameIconForDesTopAndMobile? 'h-[54px]' : 'h-[20px]'">
						<ng-container *ngIf="useSameIconForDesTopAndMobile; else mobileIconTemplateRef">
							<svg width="64" class="icon" height="54" viewBox="0 0 54 64" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect width="64" height="64" rx="19" fill="currentColor"></rect>
								<rect x="6.40039" y="6.40002" width="51.2" height="51.2" rx="16" fill="currentColor">
								</rect>
								<path
									d="M32 48.8C23.1634 48.8 16 41.6365 16 32.8C16 23.9634 23.1634 16.8 32 16.8C40.8366 16.8 48 23.9634 48 32.8C47.9903 41.6325 40.8325 48.7903 32 48.8ZM30.4 37.6V40.8H33.6V37.6H30.4ZM30.4 24.8V34.4H33.6V24.8H30.4Z"
									fill="white"></path>
							</svg>
						</ng-container>
					</div>
					<div>
						<div [class]="contentClass" class="h-full w-full flex flex-col">
							<div class="notification-bar-title">
								{{title}}
							</div>
							<div class="w-full flex justify-between h-full gap-[16px] flex-col-reverse">
								<ng-container [ngSwitch]="messageType">
									<ng-container *ngSwitchCase="messageTypes.text">
										<div class="notification-bar-msg m-t-4" [innerHTML]="message">
										</div>
									</ng-container>
									<ng-container *ngSwitchCase="messageTypes.template">
										<div class="notification-bar-msg m-t-4">
											<ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
										</div>
									</ng-container>
								</ng-container>
								<ng-container *ngIf="buttonText && !actionTemplate; else actionTemplate">
									<div class="mr-auto mt-auto">
										<app-custom-button [isSubmitting]="buttonLoading" [prefix]="buttonPrefixIcon"
											[suffix]="buttonSuffixIcon" class="mobile-action-button" type="link"
											(submitForm)="submit()" [text]="buttonText">
										</app-custom-button>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<ng-template #mobileIconTemplateRef>
	<i *ngIf="iconPath" class="icon mobile-custom-icon" nz-icon [nzType]="iconPath"></i>
	<ng-container *ngIf="!iconPath">
		<svg fill="none" class="icon" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
			<rect fill="currentColor" fill-opacity="0.3" height="32" rx="16" transform="matrix(-1 0 0 1 32 0)" width="32" />
			<rect fill="currentColor" height="25.6" rx="12.8" transform="matrix(-1 0 0 1 28.7998 3.19922)" width="25.6" />
			<path
				d="M16.001 24.4004C20.4193 24.4004 24.001 20.8187 24.001 16.4004C24.001 11.9821 20.4193 8.40039 16.001 8.40039C11.5827 8.40039 8.00098 11.9821 8.00098 16.4004C8.00583 20.8167 11.5847 24.3955 16.001 24.4004ZM16.801 18.8004V20.4004H15.201V18.8004H16.801ZM16.801 12.4004V17.2004H15.201V12.4004H16.801Z"
				fill="white" />
		</svg>
	</ng-container>
</ng-template>